const initialState = {
	data: [],
	total: 0,
	params: {},
	selectedOnlineAffiliate: {},
	sidebarOpen: false,
	sidebarStatus: 'add',
}

const onlineaffiliate = (state = initialState, action) => {
	switch (action.type) {
		case 'AFFILIATEONLINE_GET_DATA':
			return {
				...state,
				data: action.data,
				total: action.total,
				params: action.params,
			}
		case 'AFFILIATEONLINE_DEL_DATA':
			return {
				...state,
				data: state.data.filter((item) => item.id !== action.index),
				total: state.total - 1,
			}
		case 'AFFILIATEONLINE_ALL_DEL_DATA':
			return { ...initialState }
		case 'AFFILIATEONLINE_ADD_DATA':
			return {
				...state,
				data: [...state.data, action.data],
				total: state.total + 1,
			}
		case 'AFFILIATEONLINE_UPDATE_DATA':
			const updatedOnlineData = state.data.map((item) => (item.id === action.index ? action.data : item))
			return {
				...state,
				data: updatedOnlineData,
			}
		case 'AFFILIATEONLINE_GET_CURRENT':
			return {
				...state,
				selectedOnlineAffiliate: action.selectedOnlineAffiliate,
			}
		case 'AFFILIATEONLINE_SET_SIDEBAR':
			return {
				...state,
				sidebarStatus: action.status,
				sidebarOpen: !state.sidebarOpen,
			}
		default:
			return state
	}
}

export default onlineaffiliate
